import { z } from 'zod';
import { optionnelNombre } from '@shared/validation/helpers';

export const SaisieBulletinSchema = z
  .object({
    salaire_base: z.number().int().min(0),
    sursalaire: optionnelNombre(z.number().int().min(0)),
    prime: optionnelNombre(z.number().int().min(0)),
    prime_extra: optionnelNombre(z.number().int().min(0)),
    prime_logement: optionnelNombre(z.number().int().min(0)),
    prime_vehicule: optionnelNombre(z.number().int().min(0)),
    prime_anciennete: optionnelNombre(z.number().int().min(0)),
    treizieme_mois: optionnelNombre(z.number().int().min(0)),
    /** Alias formulaire manuel (BulletinFormView). */
    heures_supplementaires: optionnelNombre(z.number().min(0)),
    /** Montant HS agrégé depuis la saisie mensuelle. */
    hsup_total: optionnelNombre(z.number().int().min(0)),
    transport: optionnelNombre(z.number().int().min(0)),
    vehicule: optionnelNombre(z.number().int().min(0)),
    logement: optionnelNombre(z.number().int().min(0)),
    fonction_ind: optionnelNombre(z.number().int().min(0)),
    ind_vehicule_cnss: optionnelNombre(z.number().int().min(0)),
    ind_representation: optionnelNombre(z.number().int().min(0)),
    ind_blanchissage: optionnelNombre(z.number().int().min(0)),
    ind_vehicule_nc: optionnelNombre(z.number().int().min(0)),
    autres: optionnelNombre(z.number().int().min(0)),
    avantage_nature: optionnelNombre(z.number().int().min(0)),
    avance: optionnelNombre(z.number().int().min(0)),
    jours_travailles: optionnelNombre(z.number().min(0).max(31)),
  })
  .transform((data) => {
    const hsup =
      data.hsup_total ??
      (data.heures_supplementaires !== undefined
        ? Math.round(data.heures_supplementaires)
        : undefined);
    return { ...data, hsup_total: hsup };
  });

export const BulletinCreateFormSchema = SaisieBulletinSchema.and(
  z.object({
    salarie_id: z.string().min(1, 'Salarié requis'),
    periode: z.string().regex(/^\d{4}-\d{2}$/, 'Période AAAA-MM requise'),
  }),
);

export type SaisieBulletinInput = z.infer<typeof SaisieBulletinSchema>;
export type BulletinCreateFormInput = z.infer<typeof BulletinCreateFormSchema>;
